import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DocumentParserProvider } from '../../providers/document-parser/document-parser';
import { DataServiceProvider } from '../../providers/data-service/data-service';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';

@IonicPage()
@Component({
  selector: 'page-print-preview',
  templateUrl: 'print-preview.html',
})
export class PrintPreviewPage {
  tenant = {};
  records: any[];
  initialReportUpload = false;
  finalReportUpload = false;
  // hide the theoritical air flow for current itteration 
  showTheoriticalAirFlow = false;
  operatorText: string;
  customerData: any = {};
  constructor(public navCtrl: NavController,
    public $pdfParser: DocumentParserProvider,
    public navParams: NavParams,
    public $data: DataServiceProvider,
    public $auth: AuthServiceProvider) {
    this.records = this.$data.getItems();
    this.records = this.navParams.get('previewData').records;
    this.operatorText = this.navParams.get('previewData').operatorText;
    this.customerData = this.navParams.get('previewData').customerData;
    // gets the tennant settings data from cookies s\
    this.getTenantDetails()
  }




  getTheData() {
    let data = this.$data.getItems();
  }

  getUnit(unit, value) {
    return unit != 'N.A' && value > 0 ? unit : '';
  }

  generateRemarks(records: any[]) {
    return records.map(record => {
      record.remark = record.initialValue > 0 && record.finalValue > 0 ?
        record.finalValue - record.initialValue >= 0 ?
          record.finalValue - record.initialValue == 0 ?
            'No Change' :
            'Increased' :
          'Decreased' :
        'N.A';
      return record;
    })
  }

  // business rules to show and hide a data
  isShowable(record) {
    if (record.settingsValue == "Show Always") {
      return true;
    }
    if (record.settingsValue == "Hide Always") {
      return false;
    }
    else if (record.remark == "Increased" && record.settingsValue == "Show Decreased") {
      return false;
    }
    else if (record.remark == "Decreased" && record.settingsValue == "Show Increased") {
      return false;
    } else {
      return true;
    }
  }

  /**
     * makes a conclusion string 
     * @param item 
     */
  getConclusion(record): string {
    return this.$data.getRecordRemark(record);
  }


  getTenantDetails() {
    this.tenant = this.$auth.getCurrentUserInfo();
  }

  ionViewDidLoad() {
    // init print once the data is loaded
    setTimeout(_ => window.print(), 300);
    // shutdown the print preview page
    setTimeout(_ => this.navCtrl.pop(), 400);
  }

  getTheoritcalAirFlow(): number {
    return this.$data.getTheoriticalAirFlow(this.customerData.engineDisplacement, this.customerData.engineRpm);
  }


}



// WEBPACK FOOTER //
// ./src/pages/print-preview/print-preview.ts